// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__16qWE","ellipsis1":"style_ellipsis1__2Vydj","ellipsis2":"style_ellipsis2__uW7kl","ellipsis3":"style_ellipsis3__2GC5T"};